// actions.ts

import { Friend, Leaderboard, Task, UserData } from './type'; // Assuming the file is named types.ts

// Define action types
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_LEADERBOARD = 'SET_LEADERBOARD';
export const SET_TASKS = 'SET_TASKS';
export const SET_FRIENDS = 'SET_FRIENDS';

// Define action creators
export const setUserData = (data: UserData) => ({
  type: SET_USER_DATA as typeof SET_USER_DATA,
  payload: data,
});

export const setLeaderboard = (data: Leaderboard) => ({
  type: SET_LEADERBOARD as typeof SET_LEADERBOARD,
  payload: data,
});

export const setTasks = (data: Task[]) => ({
  type: SET_TASKS as typeof SET_TASKS,
  payload: data,
});

export const setFriends = (data: Friend[]) => ({
  type: SET_FRIENDS as typeof SET_FRIENDS,
  payload: data,
});

// Define action types with payloads
type Action =
  | ReturnType<typeof setUserData>
  | ReturnType<typeof setLeaderboard>
  | ReturnType<typeof setTasks>
  | ReturnType<typeof setFriends>;

export default Action;
